<template>
  
	<div class="htmlComposer">
		
        <textarea class="htmlComposer_textarea title" v-if="title"
        v-model="layer.popupTitle" v-on:change="changeTitle"></textarea>
        <textarea class="htmlComposer_textarea" v-if="!title"
        v-model="layer.popupHTML" v-on:change="changeContent"></textarea>
        <p><small>Write your own html code</small></p>
        <p style="user-select:text;"><small>You can add data fields in it, like {{getDataFieldDisplay()}}</small></p>

	</div>

</template>

<script>


export default {
	name: 'htmlComposer',
	props: {
		okanMap : Object,
        layer:	Object,
        title: Boolean
	},
	data: function() {
		return {

			varvar : true

		}
	},
	mounted() {
		this.init();
	},
	created() {
		
	},
	destroyed() {

	},
	methods : {

		init() {

			
        },



        changeTitle() {
            this.okanMap.popupTitle = this.layer.popupTitle;
            
        },

        changeContent() {
            this.okanMap.popupHTML = this.layer.popupHTML;
        },
        
        getFeatures() {
            return this.okanMap.sources[this.layer.sourceIndex].structure;
        },

        getDataFieldDisplay(){
            return '{' + this.getFeatures().join('}, {') + '}';
        }



	}
}
</script>


<style src="../../assets/css/ui.css"></style>